// extracted by mini-css-extract-plugin
module.exports = {"modal__header":"styles__modal__header___2cXuv","header__text":"styles__header__text___3ERVf","header__dismiss":"styles__header__dismiss___3E6mE"};